import { isFunction, isNumber } from '@antv/util';
import { GraphEvent } from '../constants';
import { cacheStyle, getCachedStyle, hasCachedStyle } from '../utils/cache';
import { idOf } from '../utils/id';
import { getDescendantShapes } from '../utils/shape';
import { BaseBehavior } from './base-behavior';
/**
 * <zh/> 缩放画布过程中固定元素大小
 *
 * <en/> Fix element size while zooming
 */
export class FixElementSize extends BaseBehavior {
    static defaultOptions = {
        enable: (event) => event.data.scale < 1,
        state: 'selected',
        edge: [
            {
                shape: (shapes) => shapes.find((shape) => shape.className === 'key'),
                fields: ['lineWidth'],
            },
            {
                shape: (shapes) => shapes.find((shape) => shape.parentElement?.className === 'label' && shape.className === 'text'),
                fields: ['fontSize'],
            },
        ],
    };
    elementCache = new Map();
    constructor(context, options) {
        super(context, Object.assign({}, FixElementSize.defaultOptions, options));
        this.bindEvents();
    }
    isZoomEvent = (event) => 'scale' in event.data;
    fixElementSize = async (event) => {
        if (!this.isZoomEvent(event) || !this.validate(event))
            return;
        const { graph, element } = this.context;
        const { node, edge, state } = this.options;
        const elementData = [...graph.getElementDataByState('node', state), ...graph.getElementDataByState('edge', state)];
        if (!elementData.length)
            return;
        const currentScale = event.data.scale || graph.getZoom();
        elementData.forEach((elementData) => {
            const id = idOf(elementData);
            const el = element?.getElement(id);
            const type = graph.getElementType(id);
            const config = type === 'edge' ? edge : node;
            if (!config) {
                this.elementCache.set(id, el);
                if (type === 'edge') {
                    el.style.transformOrigin = 'center';
                }
                // FIXME: 修改 Path 的 localScale 属性时遇到问题，导致边会偏移错位
                el.setLocalScale(1 / currentScale);
                return;
            }
            const descendantShapes = getDescendantShapes(el);
            const configs = Array.isArray(config) ? config : [config];
            configs.forEach((config) => {
                const { shape: shapeFilter, fields } = config;
                const shape = shapeFilter(descendantShapes);
                fields.forEach((field) => {
                    if (!hasCachedStyle(shape, field))
                        cacheStyle(shape, field);
                    const oriFieldValue = getCachedStyle(shape, field);
                    if (!isNumber(oriFieldValue))
                        return;
                    shape.style[field] = oriFieldValue / currentScale;
                });
            });
        });
    };
    resetTransform = async () => {
        if (this.elementCache) {
            this.elementCache.forEach((el) => el.setLocalScale(1));
            this.elementCache.clear();
        }
    };
    bindEvents() {
        const { graph } = this.context;
        graph.on(GraphEvent.AFTER_TRANSFORM, this.fixElementSize);
        graph.on(GraphEvent.BEFORE_DRAW, this.resetTransform);
    }
    unbindEvents() {
        const { graph } = this.context;
        graph.off(GraphEvent.AFTER_TRANSFORM, this.fixElementSize);
        graph.off(GraphEvent.BEFORE_DRAW, this.resetTransform);
    }
    validate(event) {
        if (this.destroyed)
            return false;
        const { enable } = this.options;
        if (isFunction(enable))
            return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
//# sourceMappingURL=fix-element-size.js.map